import { EscoHrHolidaysSection } from '../components/EscoHrHolidaysSection';

/** People > Employees > Holidays: the holiday calendar and holiday requests from escoHR, read-only. */
export function HolidaysPage() {
  return (
    <section className="card card--wide">
      <div className="section-header">
        <h2>Holidays</h2>
      </div>
      <EscoHrHolidaysSection />
    </section>
  );
}
